import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import ErrorScreen from 'app/shared/components/common/ErrorScreen/ErrorScreen';
import SplashScreen from 'app/shared/components/common/SplashScreen';
import _ from 'lodash';

import { checkIsAppLoadedInIframe } from 'utils/iframe';
import { logger } from 'utils/logger';

import { ssoSignInAction } from 'store/auth/actions';

import { tryClaimSsoTokenKey } from './Sso.utils';

const Sso = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();

  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    if (!searchParams.has('ssoTokenKey')) {
      setIsError(true);
      logger.error('No sso token was provided in URL');

      return;
    }

    const ssoTokenKey = searchParams.get('ssoTokenKey');

    if (!tryClaimSsoTokenKey(ssoTokenKey)) {
      return;
    }

    // We assume that if app loaded in iframe it is rendered in hubspot
    const isHubspotSession = checkIsAppLoadedInIframe();

    dispatch(ssoSignInAction({ ssoTokenKey, isHubspotSession })).catch(err => {
      const errorMessage = _.get(err, 'response.data', 'Unknown Error');

      setIsError(true);
      setErrorMessage(errorMessage);
    });
  }, [dispatch, search]);

  return isError ? <ErrorScreen message={errorMessage} /> : <SplashScreen />;
};

export default Sso;
